import {
  SiderResizeHandle as CoreSiderResizeHandle,
  DEFAULT_SIDER_WIDTH,
  getStoredSiderWidth,
  MAX_SIDER_WIDTH,
  MIN_SIDER_WIDTH,
  SIDER_WIDTH_STORAGE_KEY,
  useTheme,
} from '@zhiyue/core';
import type { ComponentProps } from 'react';
import styles from './SiderResizeHandle.module.less';

export {
  DEFAULT_SIDER_WIDTH,
  MAX_SIDER_WIDTH,
  MIN_SIDER_WIDTH,
  SIDER_WIDTH_STORAGE_KEY,
  getStoredSiderWidth,
};

// 复用平台拖拽、宽度存储与主题状态，仅收口边界线的视觉反馈。
const SiderResizeHandle = (
  props: ComponentProps<typeof CoreSiderResizeHandle>,
) => {
  const { navTheme } = useTheme();
  return (
    <div
      className={`${styles.boundary} ${navTheme === 'realDark' ? styles.dark : ''}`}
    >
      <CoreSiderResizeHandle {...props} />
    </div>
  );
};

export default SiderResizeHandle;
